import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import * as Table from 'reactabular-table';
import { Flex } from 'rebass';
import { bindActionCreators } from 'redux';
import * as sort from 'sortabular';
import { PvCircle, ApplicantName } from 'styles/CustomComponents';
import * as resolve from 'table-resolver';
import Spinner from '../Spinner';
import { default as theme } from "../../theme";
import Close from '@material-ui/icons/Close';
import styled from 'styled-components';
import { getApplicantAction } from 'ducks/workItem';
import { formatShortLessonDescription } from '../../util/FormatUtil';


const Undone = styled(Close)`
  color: ${props => props.theme.colors.berryRed};
`;

const status = (lessonStatus) => {

  switch (lessonStatus) {
    case 'COMPLETED':
      return  <Translate value='app.completed' />
    case 'COMPENSATED':
      return  <Translate value='app.compensated' />
    case 'UNDONE':
      return  <Translate value='app.undone' />
    case 'FAILED':
      return  <Translate value='app.failed' />
    default:
      return <Translate value={lessonStatus}/>
  }
};

const PvTooltip = (props) => {

  return <div style={{
    top: props.y + "px",
    left: (props.x + 16) + "px",
    position: "absolute",
    backgroundColor: theme.colors.additionalLessonTable.tooltip,
    zIndex: 1000,
    borderRadius: '4px',
    boxShadow: '0 0 0 2px '+ theme.shadows.insetGray2,
    padding: '15px 11px 9px'
  }}>

    <div>{status(props.lessonStatus)}</div>
    <div style={{fontWeight: 'bold'}}>{props.lessonDate}</div>
  </div>
};



class LessonsReportDataTable extends React.Component {
  constructor(props) {
    super(props);
    
    const lessonIds = new Set(
      this.props.rows.flatMap((item) => Object.keys(item.lessonData))
    );

    const columns = [
      {
        property: "name",
        header: {
          label: (
            <Flex alignItems="center" justifyContent="space-between">
              <Translate value="app.name" />
            </Flex>
          ),
          props: {
            style: {
              overflow: "hidden",
              height: "2em",
              whiteSpace: "nowrap",
              zIndex: 10,
              position: "sticky",
              top: 0,
              backgroundColor: theme.colors.white,
              borderRight: theme.borders[2],
              maxWidth: "20em",
            },
          },
        },
        props: {
          style: {
            overflow: "hidden",
            height: "2em",
            whiteSpace: "nowrap",
            left: 0,
            zIndex: 2,
            position: "sticky",
            top: 0,
            backgroundColor: theme.colors.white,
            borderRight: theme.borders[2],
            maxWidth: "20em",
          },
        },
        cell: {
          formatters: [
            (_value, props) => {
              return (
                <ApplicantName
                  title={props.rowData.name}
                  applicantStatus={props.rowData.courseData.applicantStatus}
                >
                  <span>{props.rowData.name}</span>
                </ApplicantName>
              );
            },
          ],
        },
      },
    ];

    this.props.lessons
      //Show columns only for lessons that are found in report
      .filter((lesson) => lessonIds.has(lesson.lessonId))
      .forEach((lesson) =>
        columns.push({
          property: lesson.lessonId,
          header: {
            label: (
              <Flex alignItems="center" justifyContent="space-between" title={lesson.description}>
                {formatShortLessonDescription(lesson.description)}
              </Flex>
            ),
            props: {
              style: {
                overflow: "hidden",
                height: "2em",
                whiteSpace: "nowrap",
                zIndex: 1,
                position: "sticky",
                top: 0,
                backgroundColor: theme.colors.white,
                maxWidth: "20em",
              },
            },
          },
          props: {
            style: {
              height: "2em",
            },
          },
          cell: {
            transforms: [
              (_value, props) => {
                const data = props.rowData.lessonData[props.column.property];
                if (!data) {
                  return {
                    style: {
                      backgroundColor: "#ccc",
                    },
                  };
                } else if (!!data && data.additionalLesson) {
                  return {
                    style: {
                      backgroundColor:
                        props.rowData._index % 2 === 0
                          ? theme.colors.additionalLessonTable.even
                          : theme.colors.additionalLessonTable.odd,
                    },
                  };
                }
              },
            ],
            formatters: [
              (value, props) => {
                const data = props.rowData.lessonData[props.column.property];
                if (
                  !!data &&
                  (data.status === "COMPLETED" || data.status === "COMPENSATED")
                ) {
                  return (
                    <span style={{ paddingLeft: "4px" }}>
                      <PvCircle
                        onMouseEnter={(e) => {
                          this.setState({
                            hovers: {
                              column: props.columnIndex,
                              row: props.rowIndex,
                              x: e.pageX,
                              y: e.pageY,
                              lessonDate: data.lessonDate,
                              lessonDescription: data.lessonDescription,
                              lessonTopic: data.lessonTopic,
                              lessonStatus: data.status,
                            },
                          });
                        }}
                        onMouseLeave={() => {
                          this.setState({ hovers: undefined });
                        }}
                      />
                    </span>
                  );
                } else if (
                  !!data &&
                  (data.status === "FAILED" || data.status === "UNDONE")
                ) {
                  return (
                    <Undone
                      onMouseEnter={(e) => {
                        this.setState({
                          hovers: {
                            column: props.columnIndex,
                            row: props.rowIndex,
                            x: e.pageX,
                            y: e.pageY,
                            lessonDate: data.lessonDate,
                            lessonDescription: data.lessonDescription,
                            lessonTopic: data.lessonTopic,
                            lessonStatus: data.status,
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        this.setState({ hovers: undefined });
                      }}
                    />
                  );
                }
              },
            ],
          },
        })
      );

    this.state = {
      //Table can be heavy, no sorting (or other extra stuff) for that reason.
      sortingColumns: {
      },
      columns,
      rows: resolve.resolve(
        {
          columns,
          method: resolve.nested
        },
      )(this.props.rows || [])
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      rows: resolve.resolve(
        {
          columns: this.state.columns,
          method: resolve.nested
        }
      )(props.rows || [])
    });
  }

  render() {

    const {
      stylingRenderers,
      rowKey,
    } = this.props;

    const {sortingColumns, columns, rows} = this.state;
    const finalRows =
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty
      })(rows);

    return (
      <React.Fragment>
        {this.props.loadingEntryAction && <Spinner />}
        {!!this.state.hovers &&
        <PvTooltip  lessonDate = {this.state.hovers.lessonDate}
           lessonDescription = {this.state.hovers.lessonDescription}
          x ={this.state.hovers.x} y={this.state.hovers.y} lessonTopic = {this.state.hovers.lessonTopic} lessonStatus={this.state.hovers.lessonStatus}
        />
        }
        <Table.Provider
          onMouseLeave={() => {this.setState({hovers: undefined})}}
          renderers={stylingRenderers}
          columns={columns}>
          <Table.Header />
          <Table.Body rows={finalRows} rowKey={rowKey || 'entityId'} />
        </Table.Provider>
      </React.Fragment>
    );
  }
}

LessonsReportDataTable.propTypes = {
  rows: PropTypes.array,
  stylingRenderers: PropTypes.object,
  rowKey: PropTypes.string,
  lessons: PropTypes.array,

};

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getApplicant: (id) => getApplicantAction(id),
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LessonsReportDataTable);


// WEBPACK FOOTER //
// ./src/components/datatable/LessonsReportDataTable.jsx